import { render, staticRenderFns } from "./ServiceLogin.vue?vue&type=template&id=07f87d06&scoped=true"
import script from "./ServiceLogin.vue?vue&type=script&lang=ts"
export * from "./ServiceLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f87d06",
  null
  
)

export default component.exports